// extracted by mini-css-extract-plugin
module.exports = {"generatedCodeCount":"PromotionDetails_generatedCodeCount__3lX7n pb-5","codeRow":"PromotionDetails_codeRow__xVv8V"};